import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { GuestListModalComponent } from './guest-list-modal.component';

@NgModule({
  declarations: [GuestListModalComponent],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule
  ],
  exports: [GuestListModalComponent]
})
export class GuestListModalModule {}
